// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025
import DailyCollectionReportActionTypes from './daily-collection-report.type';

/** ***************** GET DAILY COLLECTION REPORT START *********************** */
export const getDailyCollectionReportDetailsStart = (getData: any) => ({
	type: DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_START,
	payload: getData,
});

export const getDailyCollectionReportDetailsSuccess = (successData: any) => ({
	type: DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getDailyCollectionReportDetailsFailure = (failureData: any) => ({
	type: DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getDailyCollectionReportDetailsResponseResetStart = () => ({
	type: DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_RESPONSE_RESET,
});

export const getDailyCollectionReportDetailsResponseChanged = () => ({
	type: DailyCollectionReportActionTypes.GET_DAILY_COLLECTION_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DAILY COLLECTION REPORT END *********************** */
